import * as React from 'react';
import * as ReactDOMServer from 'react-dom/server';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, SwiperOptions } from 'swiper';

import { Button } from 'common/interaction';
import ChevronRight from 'vectors/icons/pagination-chevron-right.svg';
import ChevronLeft from 'vectors/icons/pagination-chevron-left.svg';
import LightningIcon from 'vectors/icons/lightning.svg';
import LightningWhiteIcon from 'vectors/icons/lightning-white.svg';

import './styles.css';
import {
  CarouselContainer,
  CarouselPaginationItem,
  CarouselWrapper,
} from './styled';

export const Carousel = <TCarouselItem extends Record<string, any>>({
  id,
  items,
  children,
  variant,
}: CarouselProps<TCarouselItem>) => {
  const swiperParams: SwiperOptions = {
    spaceBetween: 24,
    observer: true,
    slidesOffsetAfter: 24,
    slidesOffsetBefore: 24,
    pagination: {
      clickable: true,
      renderBullet: (index: number, className: string) => {
        return ReactDOMServer.renderToStaticMarkup(
          <CarouselPaginationItem className={className} index={index}>
            {variant === 'white' ? <LightningWhiteIcon /> : <LightningIcon />}
          </CarouselPaginationItem>,
        );
      },
    },
    navigation: {
      prevEl: `#prev-${id}`,
      nextEl: `#next-${id}`,
    },
  };

  return (
    <CarouselContainer width={1128} $variant={variant}>
      <CarouselWrapper>
        <Button
          variant="quarternary"
          icon={<ChevronLeft />}
          className="swiper-button-prev"
          id={`prev-${id}`}
        />
        <Swiper
          {...swiperParams}
          slidesPerView="auto"
          modules={[Navigation, Pagination]}
          className={id}
        >
          {items.map((item, index) => (
            <SwiperSlide key={`slide_${index}`}>{children(item)}</SwiperSlide>
          ))}
        </Swiper>
        <Button
          variant="quarternary"
          icon={<ChevronRight />}
          className="swiper-button-next"
          id={`next-${id}`}
        />
      </CarouselWrapper>
    </CarouselContainer>
  );
};

type CarouselProps<TCarouselItem> = {
  children: (item: TCarouselItem) => React.ReactNode;
  items: TCarouselItem[];
  id: string;
  variant?: 'white';
};
